export default __webpack_public_path__ + "static/media/load.9813568e.svg";